// extracted by mini-css-extract-plugin
module.exports =  {"main":"QJjrJrDu7JT8CJVE7_kS","wizard":"Sje3k7gpUprbNTUuoQwg"};